import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

/**
 * Globális javítás a natív dátummezőkre: ha nincs `max` (és `min`) megadva, a
 * böngésző (pl. Chrome) az évhez akár 6 számjegyet is enged beírni, így nem ugrik
 * automatikusan a hónapra. Ésszerű alapértelmezett `max`/`min` beállításával az
 * év 4 számjegyűre korlátozódik. Csak akkor lép életbe, ha az adott mezőn nincs
 * már saját korlát megadva.
 */
@Directive({
  selector: 'ion-input[type="date"]',
})
export class DateInputDefaultsDirective implements OnInit {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    const host = this.el.nativeElement as HTMLElement;
    if (!host.hasAttribute('max')) {
      this.renderer.setAttribute(host, 'max', '9999-12-31');
    }
    if (!host.hasAttribute('min')) {
      this.renderer.setAttribute(host, 'min', '1900-01-01');
    }
  }
}
